import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { CourseAssignmentDTO } from '../_models/courseAssignmentDTO';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import {
  LessonRequestDTO,
  ContentVideoRequestDTO,
  contentQuizRequestDTO,
} from '../_models/course';

@Injectable({
  providedIn: 'root',
})
export class CourseService {
  private initialCsDto: CourseAssignmentDTO = {
    ids: [],
    courseCodes: [],
    dueDate: '',
    participantType: '',
  };
  private csDTOData: BehaviorSubject<CourseAssignmentDTO> = new BehaviorSubject(
    this.initialCsDto
  );
  constructor(private http: HttpClient) {}
  createCourse(certificate, courseJson, picture) {
    const newPayload = new FormData();
    newPayload.append('courseJson', courseJson);
    newPayload.append('certificate', certificate);
    newPayload.append('picture', picture);
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createCourse}`,
      newPayload
    );
  }

  getAllCategories() {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllCategories}`
    );
  }

  getAllSubcategories(categoryId) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllSubCategories}/${categoryId}/subcategories`
    );
  }

  getllTopics(subCategoryId) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllTopics}/${subCategoryId}/all`
    );
  }

  createLesson(payload: LessonRequestDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createLesson}/${payload.courseCode}/create`,
      payload
    );
  }

  createLessonContentVideo(payload: ContentVideoRequestDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createLessonContentVideo}`,
      payload
    );
  }

  createLessonContentPdf(payload: ContentVideoRequestDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createLessonContentPdf}`,
      payload
    );
  }
  getOneLesson(id, code) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllLessons}/${code}/find/${id}`
    );
  }
  getCourseById(courseCode) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getCourseById}/${courseCode}`
    );
  }

  getAllLessons(code) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllLessons}/${code}/all`
    );
  }

  getAllCourses(id) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllCourses}/${id}`
    );
  }

  getAllCompanyCourses() {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllCoursesByCompany}`
    );
  }
  updateLesson(lessonId, payload: LessonRequestDTO) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.getAllLessons}/${payload.courseCode}/update/${lessonId}`,
      payload
    );
  }

  updateCourse(certificate, courseCode, courseJson, picture) {
    const newPayload = new FormData();
    newPayload.append('courseJson', courseJson);
    newPayload.append('certificate', certificate);
    newPayload.append('picture', picture);
    newPayload.append('courseCode', JSON.stringify(courseCode));
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateCourse}/${courseCode}/update`,
      newPayload
    );
  }
  updateContentVideo(lessonContentId, payload) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateContent}/${lessonContentId}/video_update`,
      payload
    );
  }
  updateContentPdf(lessonContentId, payload) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateContent}/${lessonContentId}/pdf_update`,
      payload
    );
  }

  createQuiz(payload: contentQuizRequestDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createLessonContentQuiz}`,
      payload
    );
  }

  rateCourse(courseCode, payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.rateCourse}/${courseCode}/rate`,
      payload
    );
  }

  createComment(courseCode, payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createComment}/${courseCode}/comment`,
      payload
    );
  }

  replyComments(commentId, payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.replyComment}/${commentId}/reply`,
      payload
    );
  }

  getComments(courseCode, pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getComments}/${courseCode}/comments`,
      { params }
    );
  }

  toggleEnroll(courseCode) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.enroll}/${courseCode}/toggle_enroll`,
      null
    );
  }

  // unEnroll(courseCode) {
  //   return this.http.post(
  //     `${environment.API_URL_V1}/${endpoints.unEnroll}/${courseCode}/un_enroll`,
  //     null
  //   );
  // }
  deleteFileFromCloudinary(id) {
    const params = new HttpParams().set('cloudinaryId', id);
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteFileFromCloudinary}`,
      { params }
    );
  }

  deletecontent(lessonContentId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteContent}/${lessonContentId}/delete`
    );
  }

  deleteLesson(courseCode, lessonId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteLesson}/${courseCode}/delete/${lessonId}`
    );
  }

  getOneContent(lessonContentId) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getOneContent}/${lessonContentId}`
    );
  }
  getCsDTOData() {
    return this.csDTOData.asObservable();
  }
  setIdData(response: { ids?: any[]; courseCodes?: any[]; dueDate?: '' }) {
    this.csDTOData.forEach((next) => {
      next.ids = response.ids;
    });
  }

  setParticipantType(response: { participantType: string }) {
    this.csDTOData.forEach((next) => {
      next.participantType = response.participantType;
    });
  }

  setCourseData(response: { ids?: any[]; courseCodes?: any[]; dueDate?: '' }) {
    this.csDTOData.forEach((next) => {
      next.courseCodes = response.courseCodes;
    });
  }
  setDateData(response: { ids?: any[]; courseCodes?: any[]; dueDate?: '' }) {
    this.csDTOData.forEach((next) => {
      next.dueDate = response.dueDate;
    });
  }
  reset() {
    this.csDTOData.next(this.initialCsDto);
  }

  assignCourseToStaffs(payload: CourseAssignmentDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignCourseToIndividual}`,
      payload
    );
  }
  assignCourseToDepartments(payload: CourseAssignmentDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignCourseToDepartment}`,
      payload
    );
  }
  assignCourseToDivisions(payload: CourseAssignmentDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignCourseToDivision}`,
      payload
    );
  }
  assignCourseToUnits(payload: CourseAssignmentDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignCourseToUnit}`,
      payload
    );
  }
  courseProgress(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.courseProgressUpdate}`,
      payload
    );
  }

  toggleSavedCourse(courseCode, payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.toggleSaveCourse}/${courseCode}/toggle_save`,
      payload
    );
  }

  savedCourses(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.savedCourses}`,
      { params }
    );
  }

  getAssessmentResultHistory(id, pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${
        endpoints.assessmentResultHistory
      }/${id}/${'result_history'}`,
      { params }
    );
  }

  enrolledCourses(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getEnrolledCourses}`,
      { params }
    );
  }

  markAssessment(id, payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.markAssessment}/${id}/mark`,
      payload
    );
  }

  toggleLikeCourse(courseCode, payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.toggleLikeCourse}/${courseCode}/toggle_like`,
      payload
    );
  }

  likedCourses(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.likedCourses}`,
      { params }
    );
  }

  deleteCourse(courseCode) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteCourse}/${courseCode}/delete`
    );
  }

  unassignCourse(payload: { code: string; id: number }) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.unassign}`,
      payload
    );
  }
}
